import { CodeBlock } from '../CodeBlock/CodeBlock';
import { ControlBlock, isControlType } from '../ControlBlock/ControlBlock';
import { ContentParser } from './ContentParser';
import { CodeBlockNode } from './types';

/**
 * Renders CodeBlockNode tree as React components
 */
export class NodeRenderer {
  private contentParser = new ContentParser();

  setColorDefinitions(colorDefinitions: Map<string, string>) {
    this.contentParser.setColorDefinitions(colorDefinitions);
  }

  render(node: CodeBlockNode, index: number): React.ReactNode {
    if (node.type === 'control') {
      return this.renderControlBlock(node, index);
    }

    if (node.type === 'code' && node.content) {
      return this.renderCodeBlock(node, index);
    }

    return null;
  }

  private renderControlBlock(node: CodeBlockNode, index: number): React.ReactNode {
    const condition = typeof node.condition === 'string' ? this.contentParser.parseCondition(node.condition) : node.condition;

    if (!isControlType(node.controlType)) {
      throw new Error(`Unknown control type: ${node.controlType}`);
    }

    return (
      <ControlBlock key={index} type={node.controlType} condition={condition} indent={node.indent} color={node.color}>
        {node.children?.map((child, i) => this.render(child, i))}
      </ControlBlock>
    );
  }

  private renderCodeBlock(node: CodeBlockNode, index: number): React.ReactNode {
    const content = this.contentParser.parseCondition(node.content!);

    return (
      <CodeBlock key={index} color={node.color} indent={node.indent}>
        {content}
      </CodeBlock>
    );
  }
}
